const organisationOnboard = {
  id: 'organisationOnboard',
  title: '',
  type: 'group',
  Breadcrumbs:false,
  children: [
    {
      id: 'customer-collapse',
      title: 'Organisation',
      type: 'collapse',
      Breadcrumbs:false,
      children: [
        {
          id: 'organisation',
          title: 'Organisation',
          type: 'item',
          url: '/organisation',
          Breadcrumbs:false,
        },
        {
          id: 'outlet',
          title: 'Outlet',
          type: 'item',
          url: '/organisation/outlet',
          breadcrumbs:false,
        },
        {
          id: 'users',
          title: 'User',
          type: 'item',
          url: '/organisation/outlet/user'
        },
       
      ]
    }
  ]
};

export default organisationOnboard;
export {}; 

